const paymentDataOffline = {
    "screen": "offline-payment",
    "formData": {
        "brandLogo": "images/logos/swatch.png",
        "title": "Reloses de suach",
        "redirectUrl": "",
        "cancelUrl": "http://redb.ee/",
        "successUrl": "http://redb.ee/",
        "documentTypes": "{'DNI': 1, 'LE': 3, 'LC': 4, 'Credencial de Elector': 5, 'Pasaporte': 7}"
    },
    "paymentData": {
        "cardBin": "",
        "paymentMethod": [51],
        "installments": 6,
        "cardLogo": "pago-mis-cuentas",
        "amount": "2.999,99",
        "currency": "$",
        "eachInstallment": "499,99"
    }
}

const paymentData = {
    "screen": "payment",
    "formData": {
        "brandLogo": "images/logos/swatch.png",
        "title": "Reloses de suach",
        "redirectUrl": "",
        "cancelUrl": "http://redb.ee/"
    },
    "paymentData": {
        "cardBin": "",
        "paymentMethod": [1, 42, 61, 31, 111, 113, 140, 141],
        "binRanges": {
            1:      { priority: 2, luhn:true, ranges: [{inferior: "400000", superior: "499999"}]},
            42:     { priority: 0, luhn:true, ranges: [{inferior: "520053", superior: "520053"},
                                            {inferior: "546553", superior: "546553"},
                                            {inferior: "487017", superior: "487017"}]},
            61:     { priority: 0, luhn:true, ranges: [{inferior: "421024", superior: "421024"}]},
            111:    { priority: 0, luhn:false, ranges: [{inferior: "373953", superior: "373953"}]},
            113:    { priority: 0, luhn:false, ranges: [{inferior: "621978", superior: "621978"}]},
            31:     { priority: 1, luhn:true, ranges: [{ inferior: "400276", superior: "400276"},
                                            { inferior: "400448", superior: "400448"},
                                            { inferior: "400615", superior: "400615"}]},
            140:    { priority: 0, luhn:true, ranges: [{inferior: "560718", superior: "560718"}]},
            141:    { priority: 1, luhn:false, ranges: [{inferior: "627893", superior: "627893"}]}
        },
        "installments": 6,
        "cardLogo": "confiable",
        "amount": "2.999,99",
        "currency": "$",
        "eachInstallment": "499,99"
    }
}


const feedbackDataOffline = {
    "screen": "offline-feedback",
    "formData": {
        "brandLogo": "images/logos/swatch.png",
        // "title": "Reloses Temporada Primavera - Verano",
        "successUrl": "http://google.com.ar"
    },
    // Con error
    /*"resultData": {
        success: false,
        error: {
            message: "voló, y me hizo volar, y yo volé de él",
            //timeout: true
        }
    }*/
    // Sin error
    resultData: {
        success: true,
        error: {},
        currency: "$",
        amount: "10,00",
        authCode: "",
        date: "14/02/2019 18:30:32",
        last4Digits: "",
        installments: 10,
        cardLogo: "pago-mis-cuentas",
        paymentMethodId: 26,
        expirationDate: "19/12/20",
        operationNumber: 123123414,
        barCode: "12312348888888812312312191220000010000500001230101",
        paymentMeanName: "PagoMisCuentas",
        establishmentName: "Prueba de carga",
        surcharge: "",
        secondExpirationDate: "",
    }

}

const feedbackData = {
    "screen": "feedback",
    "formData": {
        "brandLogo": "images/logos/swatch.png",
        "title": "Reloses de suach",
        "successUrl": "http://google.com.ar"
    },
    // Con error
    /*"resultData": {
        success: false,
        error: {
            message: "voló, y me hizo volar, y yo volé de él",
            //timeout: true
        }
    }*/
    // Sin error
    "resultData": {
        success: true,
        error: {},
        currency: "$",
        amount: "420.00",
        authCode: "123123123123",
        date: "12/01/2019   05:04:03",
        last4Digits: "4444",
        installments: 3,
        cardLogo: "visa"
    }
}

const errorData = {
    "screen": "feedback",
    "formData": {
        "brandLogo": "images/logos/swatch.png",
        "title": "Reloses de suach",
        //"successUrl": "http://google.com.ar"
    },
    "resultData": {
        success: false,
        error: "OnlinePaymentError"
    }
}

export default paymentData
